module.exports = __webpack_public_path__ + "img/r7.9e603547.png";